import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api from "../../services/api";
import Cookies from "js-cookie";
import { useKitchenAuth } from "../../context/KitchenAuthContext";

interface LoginResponse {
  success: boolean;
  token: string;
  data: {
    id: string;
    name: string;
    email: string;
    role: string;
    restaurantId: string;
  };
}

const Kitchenlogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useKitchenAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await api.post<LoginResponse>("/new/emplogin", {
        email,
        password,
      },{withCredentials:true}
);

      if (data.success) {
        Cookies.set("emptoken", data.token);
        login({ user: data.data, token: data.token });
        // toast.success("Login successful!");
        window.hasVerifiedKitchenToken = true;
        navigate("/kitchen");
      } else {
        toast.error("Login failed");
      }
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 401) {
          toast.error("Invalid email or password");
        } else if (error.response.status === 400) {
          toast.error(error.response.data?.error || "Invalid request");
        } else if (error.response.data?.error) {
          // e.g. 402: the restaurant's account is suspended/trial-expired
          toast.error(error.response.data.error);
        } else {
          toast.error("Login failed. Please try again.");
        }
      } else if (error.request) {
        toast.error("Network error. Please check your connection.");
      } else {
        toast.error("Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-full max-w-md p-8 bg-[#FCFCFC] rounded-lg border border-gray-500 shadow-md">
        <span className="font-outfit text-left text-black font-bold text-4xl">
          Login
        </span>

        <form onSubmit={handleSubmit}>
          <div className="mb-4 mt-6">
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email Address"
              className="w-full p-3 border border-gray-300 font-outfit rounded-md text-base focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <div className="mb-6">
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Password"
              className="w-full p-3 border border-gray-300 font-outfit rounded-md text-base focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          {/* <div className="text-sm mb-6 text-right">
            <a className="text-blue-600 hover:underline">Forgot password?</a>
          </div> */}

          <button
            type="submit"
            disabled={loading}
            className={`w-full p-3 text-white text-lg font-outfit font-medium rounded-xl transition-all duration-100
    ${
      loading
        ? "bg-[#F3726E] opacity-70 cursor-not-allowed"
        : "bg-[#F3726E] hover:bg-[#F25C58] hover:shadow-lg transform hover:scale-105"
    }
  `}
          >
            {loading ? "Logging in..." : "Log in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Kitchenlogin;
